<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
            <LayoutHeader />
		</div>
        <div class="banner-box">
            <img src="@/assets/home/kzfw-banner.png" alt="">
            <div class="text-box">
                <div class="text1">新办主体刻章服务   ·   便捷高效助力创业   ·   规范印鉴护航发展</div>
                <div class="text2">新办经营主体刻章服务</div>
                <!-- <div class="button">查看我的评审</div>-->
            </div>
    </div>
        <div class="breadBox">
            <div class="child">
                <a-breadcrumb>
            <span>
              当前位置：
            </span>
                    <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页
                    </a-breadcrumb-item>
                    <a-breadcrumb-item>新办经营主体刻章服务</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
		<div style="width: 1200px;min-height:556px;margin: 20px auto 116px;">
            <a-card style="margin-bottom: 20px;">
                <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
                    <a-form-item label="提交时间" name="companyName">
                        <range-picker v-model:startDate="searchForm.startDate" v-model:endDate="searchForm.endDate" />
                    </a-form-item>
                    <div class="hidden">
                        <a-form-item label="companyCode" name="companyCode">
                            <a-input style="width:100%" v-model:value="searchForm.companyCode" />
                        </a-form-item>
                    </div>
                    <a-form-item label="申请进度" name="schedule">
                        <a-select v-model:value="searchForm.schedule" placeholder="请选择审核状态">
                            <a-select-option value="0">申请中</a-select-option>
                            <a-select-option value="1">通过</a-select-option>
                            <a-select-option value="2">不通过</a-select-option>
                            <a-select-option value="3">印章刻制中</a-select-option>
                            <a-select-option value="4">印章刻制完成，请到站点取章</a-select-option>
                            <a-select-option value="5">初审通过</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="onSearch">查询</a-button>
                        <a-button @click="onReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </a-card>

				<a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
					<template #message>
						已选择 {{ selectedRowKeys.length }} 项
						<a @click="onClearSelected" class="ml-20 float-right">清空</a>
					</template>
				</a-alert>
				<a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
					:pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
					<template #companyName="{ record }">
						<a @click="onDetail(record)">{{ record.companyName }}</a>
					</template>
					<template #schedule="{ record }">
						<span style="color:#0059B5;border:1px solid #0059B5;background: #e5eef7;padding: 6px 15px;border-radius: 4px;" v-if="record.schedule == '0'">申请中</span>
						<!-- <span style="color:red" v-if="record.schedule=='1'">未通过</span> -->
						<a-popover v-if="record.schedule == '1'" placement="bottom">
							<template #content v-if="record.reason">
								<p>{{ record.reason }}</p>
							</template>
							<template #title>
								<span>未通过原因</span>
							</template>
							<a style="color:#DD0F31;border:1px solid #DD0F31;background: #fce7ea;padding: 6px 15px;border-radius: 4px;">未通过</a>
						</a-popover>
						<a-popover v-if="record.schedule == '5'" placement="bottom">
							<template #content v-if="record.reason">
								<p>{{ record.reason }}</p>
							</template>
							<template #title>
								<span>初审通过</span>
							</template>
							<a style="color:#00B51A;border:1px solid #00B51A; background: #e5f7e8;padding: 6px 15px;border-radius: 4px;">初审通过</a>
						</a-popover>
						<span style="color:#00B51A;border:1px solid #00B51A;background: #e5f7e8;padding: 6px 15px;border-radius: 4px;" v-if="record.schedule == '2'">已通过</span>
						<span style="color:gold" v-if="record.schedule == '3'">印章刻制中</span>
						<span style="color:#87d068" v-if="record.schedule == '4'">印章刻制完成，请到站点取章</span>
					</template>
					<template #mailingAddress="{ record }">
						<span v-if="record.mailingAddress == 0">阳泉高新区政务大厅 北海路8号 0353-2292800</span>
						<span v-if="record.mailingAddress == 1">邮寄</span>
					</template>
					<template #submitTime="{ record }">
						<span :class="{ clred: !record.submitTime }">{{ record.submitTime ? record.submitTime.split(' ')[0] :
							'未提交' }}</span>
					</template>
					<template #action="{record}">
						<a @click="onDetail(record)" style="color: #0059B5;">详情 </a>
						<a v-if="record.isSubmit == 0" @click="onEdit(record)" style="color: #0059B5;"> 编辑 </a>
                        <a v-if="showImprove && errCompany.includes(record.companyName)" style="color: #0059B5;" @click="onImprove(record)"> 更新资料</a>
						<!-- <a v-if="record.isSubmit==0" @click="onSubmit(record)"> 提交</a> -->
					</template>
				</a-table>
		</div>
		<LayoutFooter />
	</div>
	<Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel" />
    <improve-modal ref="improve" @finish="onFormFinish"/>
</template>

<script>
// import { appAdaptation } from "../../utils/convertData";
import { dictMixin } from "@/mixins";
import { ls } from "@/utils/util"
import axios from "axios";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import dataCheck from "@/utils/dataCheck";
import { common, phoneCommon } from "@/api/finance"
import { notification } from "ant-design-vue";
import { file_service, register_mp } from "@/api/adminService";
import { companyInfo } from '@/api/companyService';
// import Detail from "./components/Detail";
import Detail from "./components/DetailModal";
import { tableListMixin } from "@/mixins";
import { enterpriseEngraveApply } from "@/api/EnterpriseSealService";
import { dateFormat } from "@/config/variableConfig";
import ImproveModal from "./components/ImproveModal";
// 文件信息有错误的手机号  用于开放完善资料按钮
const errPhone = "17809242359,13044465789,13044467553,13097606121,13103533933,13111236543,13111236543,13133231515,13152730167,13152738262,13223531688,13223534447,13223537199,13293630534,13293836808,13327409130,13333531127,13393534351,13393535566,13403530033,13403532444,13453313333,13546131111,13643678759,13663430034,13693100659,13700531611,13700532755,13700539049,13703533116,13703533116,13753300031,13754801825,13835324486,13835324486,13835328982,13840018851,13903539845,13935309292,13935367153,13935372322,13935378968,13935383097,13994494321,14706309484,15003531020,15035313302,15035332003,15135400475,15234313768,15234320622,15535329592,15535332020,15535335556,15635337180,15835301581,15835304443,15835314574,15835346668,15846607780,15903538583,16603531226,16635300188,17302256756,17312151234,17603433583,17603531629,17710298484,18235381654,18235381654,18235381654,18235390099,18235390099,18235390099,18335314009,18335314009,18335314009,18335320798,18335358808,18335374083,18354435555,18435373989,18438373704,18535326066,18635307846,18635378769,18672188877,18735313114,18735320009,18735320009,18735320009,18735320009,18935300818,19581989199,19834097049,19835134550,19835138805,19903519656,19935517727"
const errCompany = "山西诺云信息技术有限公司,阳泉高新技术产业开发区老毕汽修服务中心（个体工商户）,阳泉高新技术产业开发区青云趣团租赁服务中心（个体工商户）,阳泉义城医疗救援护送服务有限公司,阳泉王垅惠康农业科技有限公司,阳泉玲珑信息咨询有限公司,山西悦诚商贸有限公司,阳泉高新技术产业开发区鸿辉机电日常综合维修部（个体工商户）,阳泉高新技术产业开发区冰晶妆绘馆,阳泉高新技术产业开发区维翔管理有限公司,阳泉高新技术产业开发区丰泰农产品经销部（个体工商户）,阳泉高新技术产业开发区笑笑百货店（个体工商户）,阳泉市雨泉文化传媒有限公司,阳泉天使口腔有限公司,阳泉市滋生堂毓芳诊所有限公司,阳泉威尔科技有限公司,山西坤搏贸易有限公司,中人建设集团第一工程有限公司阳泉分公司,阳泉高新技术产业开发区一号鲜花店,阳泉市友联服务有限公司,阳泉市高新技术产业开发区安顺发建材经营部（个体工商户）,阳泉市众联运输有限责任公司,阳泉市鑫苑商贸有限公司,阳泉高新技术产业开发区超模型发店（个体工商户）,阳泉高新技术产业开发区鼎晟教育咨询服务中心（个体工商户）,阳泉邀约圈文化传播有限责任公司,山西祥顺电力工程有限公司阳泉分公司,阳泉浩源房地产开发有限公司,阳泉市高新技术产业开发区天惠通讯服务中心,山西丰硕项目管理有限公司,山西广聚新能源有限公司,阳泉兴拓建筑工程有限公司,山西方禹环保咨询有限公司阳泉分公司,阳泉高新技术产业开发区花海鲜花礼品店（个体工商户）,山西华信国际旅行社有限公司新澳城营业部,阳泉高新技术产业开发区安华建材经营部（个体工商户）,山西创世霖淼生物科技有限公司,阳泉高新技术产业开发区桃河酒店（个体工商户）, 阳泉高新技术产业开发区凌炜商行（个体工商户）,阳泉市鹏程致远科技有限公司, 山西东鑫物业有限公司,山西盈众成商贸有限公司,阳泉高新技术产业开发区中盈物资经贸中心（个体工商户）,阳泉高新技术产业开发区动感青春通讯店,阳泉市臻诚车业有限责任公司,阳泉高新技术产业开发区头羊音乐琴行东城水岸店（个体工商户）,阳泉高新技术产业开发区永盛销售服务部（个体工商户）,东利颐康（山西）医疗科技有限公司, 山西鼎阳机电设备有限公司,阳泉高新技术产业开发区中信服务中心（个体工商户）, 阳泉市臻养元古方堂健康咨询有限公司泉西路经营部,阳泉高新技术产业开发区冯氏祥汇酒行（个体工商户）,阳泉高新技术产业开发区任姐炒货店（个体工商户）,阳泉高新技术产业开发区瑞景烟酒茶行,阳泉高新技术产业开发区金蜜无间食品销售店（个体工商户）,阳泉正典装饰工程有限公司,阳泉高新技术产业开发区星空露营百货铺（个体工商户）,阳泉丰泽农业专业合作社, 阳泉高新技术产业开发区嘉艺嗨吃百货店（个体工商户）, 阳泉熙丞科技有限公司,阳泉高新技术产业开发区康健乐技术服务部（个体工商户）,山西红果科技有限公司,阳泉杏坛物业管理有限公司,阳泉翎创信息科技有限公司,阳泉高新技术产业开发区宝宝商务中心,阳泉高新技术产业开发区水星家具店,阳泉高新技术产业开发区御鉴臻品保健养生店（个体工商户）,阳泉高新技术产业开发区润博咨询管理中心（个体工商户）,阳泉政星商贸有限公司,山西嘉禾瑞商贸有限公司,山西恒运达汽车服务有限公司," +
    "阳泉高新技术产业开发区海鑫发艺室（个体工商户）,阳泉市逸宅装饰工程有限公司,阳泉市正阳建筑工程有限公司,顶点地产科技服务（山西）有限公司,阳泉高新技术产业开发区微辣小火锅店（个体工商户）,阳泉市星辰互娱网络科技有限公司,山西证保云环保有限公司,阳泉高新技术产业开发区新锐工贸经营部（个体工商户）,阳泉高新技术产业开发区瑞鑫广告店（个体工商户）, 山西省光碳能源科技有限公司, 阳泉高新技术产业开发区三泉百货店（个体工商户）, 阳泉高新技术产业开发区锦琪商贸中心（个体工商户）,阳泉高新技术产业开发区西来顺牛羊肉店, 阳泉高新技术产业开发区聚友大排档,阳泉融和国川新能源有限公司,阳泉市大肚皮餐饮店,山西骏鑫信息技术服务有限公司,阳泉市联盛新材料有限公司,阳泉高新技术产业开发区鼎盛吉商贸中心（个体工商户）,阳泉市莫比科技有限公司,山西泉味美食品科技有限公司,阳泉高新技术产业开发区书香门第九溪树美容美体店（个体工商户）,阳泉高新技术产业开发区椿光图文打印工作室（个体工商户）,阳泉市卓萃电子商务有限公司,山西尚艺劳务有限公司,阳泉博源工程有限公司,阳泉万德酒店管理有限公司,太原正尚法律咨询有限公司阳泉分公司"
const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	{title: "企业名称", dataIndex: "companyName", key: "companyName", slots: {customRender: "companyName"},width: "200px"},
	// {title: "经办人", dataIndex: "agent", key: "agent"},
	// { title: "领取方式", dataIndex: "collectionMethod", key: "collectionMethod", slots: { customRender: "collectionMethod" } },
	// {title: "是否为新办市场主体", dataIndex: "isMarket", key: "isMarket", slots: {customRender: "isMarket"}},
	// {title: "是否个转企", dataIndex: "isEnterprise", key: "isEnterprise", slots: {customRender: "isEnterprise"}},
	{ title: "取章地址", dataIndex: "mailingAddress", key: "mailingAddress", slots: { customRender: "mailingAddress" } },
	{ title: "提交时间", dataIndex: "submitTime", key: "submitTime", slots: { customRender: "submitTime" } },
	{ title: "申请进度", dataIndex: "schedule", key: "schedule", slots: { customRender: "schedule" } },
	// {title: "缴税总额", dataIndex: "totalTax", key: "totalTax"},
	{ title: "操作", fixed: 'right', dataIndex: "action", key: "action", slots: { customRender: "action" }, width: "160px" },
];
export default {
	name: "信息补充",
	mixins: [tableListMixin, dictMixin],
	components: {
        ImproveModal,
		Detail,
		LayoutFooter,
        LayoutHeader
	},
	data() {
		return {
            showImprove:false,
            errCompany,
			waitTime: 61,
			all_logo: '',
			// dictNames: 'policy_type',
			user: {},
			formState: {
				user: undefined,
			},
			webSiteInfo: {},
			linkData: [],
			pwOk: null,
			companyShow: null,
			optionsRoleTreeList: null,
			optionsMechanIsmTreeList: null,
			optionsBaseTreeTreeList: null,
			optionsTreeList: null,
			codeLength: 4,
			inputvalue: '',
			show: false,
			showerror: false,
			platformName,
			confirmLoading: false,
			codeBtnWord: '获取短信验证码',
			form: {
				phoneNumber: null,
				password: null,
				watmal: null,
				newpassword: null,
				// captcha: null,
			},
			rules: {
				phoneNumber: [
					dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				],
				newpassword: [
					dataCheck.required({ msg: '用户名不能为空' }), dataCheck.password,
				],
				password: [
					dataCheck.required({ msg: '密码不能为空' }),
				],
				watmal: [
					dataCheck.required({ msg: '短信验证码不能为空' }),
				]
				// captcha: [
				//     dataCheck.required({msg: '验证码不能为空'}),
				// ],
			},
			captchaPath: '',
			redirectPath: '/',

			dateFormat,
			dictNames: 'isPublic,serviceStatus,condition,demand_type',
			columns,
			queryParam: {
				companyCode: this.$route.query.id
			},
			listUrl: null,
			listKeyField: "id",
			deleteUrl: enterpriseEngraveApply.remove
		}
	},


	methods: {
		/**
		 * @description: 封装JWT heaers 函数
		 * @param {*} method
		 * @param {*} url
		 * @param {*} params
		 * @param {*} fun
		 * @return {*}
		 */
		getAxios(method, url, params, fun) {
			axios({
				method: method,
				headers: {
					AuthenticationPhone: ls.get('jwtphone'),
					AuthenticationJwt: ls.get('jwtMain')
				},
				url: url,
				params: params.params
			}).then(res => {

				if(res.data.code==544){
					notification.warning({
						message: '登录过期',
						style: {
							width: '400px',
							fontWeight: '600',
							marginLeft: `${-200}%`,
							marginTop: `${20}%`,
						}
					});
					setTimeout(() => {
							this.$router.push('/')
					}, 50);
				}else{
					if (res) {
						fun(res)
					}
				}
			})
		},

		/*加载数据*/
		loadData(pageNum) {

								this.dataSource = null;
                let params = this.getParameters();
								params["pageNum"] = pageNum
										? pageNum
										: this.pagination.current || 1;
								params["pageSize"] = this.pagination.pageSize;
								params["companyCode"] = this.$route.query.id;
                this.loading = true;
								this.getAxios('get',enterpriseEngraveApply.pageList,{
									params
								}, (res) => {
									this.dataSource = res.data.data.records;
									this.pagination.current = res.current;
									this.pagination.total = res.total;
									this.loading = false;
								})
        },

		getPhoneCode() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((value) => {
					this.postAction({
						url: phoneCommon.retrievePwd,
						params: {
							phone: value.phoneNumber
						}
					}
					).then((res) => {
						if (res.code == '0') {
							this.waitTime = (res.msg * 60) + 1
							this.waitTime--;
							this.$refs.codeBtnWordMarkid.style.zIndex = 1
							this.codeBtnWord = `${this.waitTime}s 后获取`;
							let timer = setInterval(() => {
								if (this.waitTime > 1) {
									this.waitTime--;
									this.codeBtnWord = `${this.waitTime}s 后获取`;
								} else {
									clearInterval(timer);
									this.codeBtnWord = "获取短信验证码";
									this.$refs.codeBtnWordMarkid.style.zIndex = -1
									this.waitTime = 61;
								}
							}, 1000);
							notification.success({
								message: '验证码发送成功，请查看手机短信',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '验证码发送失败，请稍后重新发送',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
					})
				})
		},
		getCode() {

			this.$refs.ruleForm
				.validate('phoneNumber')
				.then(() => {
					this.postSeed()
					// this.waitTime--;
					// this.$refs.codeBtnWordMarkid.style.zIndex = 1
					// this.postSeed()
					// this.codeBtnWord = `${this.waitTime}s 后获取`;
					// let timer = setInterval(() => {
					// 	if (this.waitTime > 1) {
					// 		this.waitTime--;
					// 		this.codeBtnWord = `${this.waitTime}s 后获取`;
					// 	} else {
					// 		clearInterval(timer);
					// 		this.codeBtnWord = "获取邮箱验证码";
					// 		this.$refs.codeBtnWordMarkid.style.zIndex = -1
					// 		this.waitTime = 61;
					// 	}
					// }, 1000);
				})
				.catch(() => {
				})
		},

		postSeed() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((values) => {
					this.confirmLoading = true;
					this.postAction({
						url: common.sendCode,
						params: {
							mobilePhone: values.phoneNumber,
						}
					}
					).then((res) => {
						if (res.code == '0') {
							notification.success({
								message: '验证码发送成功，请查看邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '邮箱不存在，请联系平台管理员补充邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: '今日验证码已达上限，24小时后重新申请',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: '邮箱功能未开通，联系管理员设置',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '4') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
						this.confirmLoading = false;
						// this.$router.push(this.redirectPath);
					}).catch((err) => {
						console.log(err, 'err')
						this.confirmLoading = false;
					})
				})
				.catch(() => {
				})
		},

		getNew(e) {
			if (e.target.value != this.form.newpassword) {
				this.pwOk = false
			} else {
				this.pwOk = true
			}
		},
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},

		subPhone() {
			var valiSome = ['phoneNumber']
			this.$refs.ruleForm.validate(valiSome).then(() => {
				this.getAction({
					url: register_mp.verifyUniquePhone,
					params: {
						phoneNumber: this.form.phoneNumber
					}
				}
				).then((res) => {
					if (res) {
						this.$notification.error({
							message: '该手机号未注册！',
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					} else {
						this.getPhoneCode()
						this.$notification.success({
							message: ('手机号可用，请继续操作！'),
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					}
				})
			})
		},
		getTableData(id) {

			this.getAxios('get', enterpriseEngraveApply.queryData, {
				params:{companyCode: id}
			}, (res) => {
				console.log(res,'queryData')
				this.dataSource = res.data.data
			})
		},
		onAdd() {
			this.getAction({
				url: companyInfo.detail
			}).then(res => {
				if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
					this.$router.push({ path: '/EnterpriseSealService/Add' })
				} else {
					this.$message.warning('请完善企业基本信息！')
					this.$router.push({ path: '/companyInfo' })
				}
			})
		},
		onEdit(record) {

			this.$router.push({ path: '/EnterpriseSealService/Add', query: { id: record.id, gourl: 'list' } })
			// this.getAction({
			//     url: enterpriseEngraveApply.detail,
			//     params: {id: record.id}
			// }).then(() => {
			//     this.$router.push({path: '/sys/EnterpriseSealService/Add', query: {id: record.id}})
			// })
		},
        onImprove(record){
            console.log(record)
            this.onShowModal("improve", {...record})
        },
        onFormFinish(){
            this.loadData(1);
        },
		onSubmit(record) {

			this.getAxios('post', enterpriseEngraveApply.submit, {
				params:{id: record.id,
				isSubmit: 1}
			}, (res) => {
				if (res) {
					this.loadData();
				}
			})
		},
		onDetail(record) {
			this.getAxios('get', enterpriseEngraveApply.detail, {
				params:{id: record.id}
			}, (res) => {
				this.onShowModal("detailmodal", res.data.data)
			})
		},

		exportExcelTemplate0() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal0,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章刻制流转单模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
		exportExcelTemplate1() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal1,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章备案登记表模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
		exportExcelTemplate2() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal2,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章委托书模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
	},

	mounted() {
		this.all_logo = this.$ls.get('all_logo');
        const id = this.$route.query.id;
        this.getTableData(id)
        this.showImprove = errPhone.includes(id);
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>

<style scoped lang="less">
.banner-box {
    position: relative;

    img {
        width: 100%;
        height: 282px;
        object-fit: cover;
    }

    .text-box {
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);

        .text1 {
            width: 100%;
            font-weight: 400;
            font-size: 20px;
            color: #C5EDF6;
            line-height: 50px;
        }

        .text2 {
            width: 100%;
            font-weight: 400;
            font-size: 40px;
            color: #FFFFFF;
            line-height: 50px;
            margin: 10px 0 30px 0;
        }

        .button {
            background: linear-gradient(90deg, #FF8F14, #FF5C0A);
            box-shadow: 0px 0px 1px 0px #FFFFFF;
            border-radius: 4px;
            color: #fff;
            width: 160px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
    }
}
.breadBox {
    width: 100% !important;
    padding:0 !important;
    border-bottom: 1px solid #DEDEDE;

    .child {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;

    }
}
.clred {
	color: red
}

.codeBtnWordMark {
	width: 100%;
	height: 40px;
	background: rgba(136, 135, 135, 0.6);
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}

					.btnBB {
						width: 300px;
						margin: 0 auto;
					}

					:deep(.ant-form-item-label > label) {
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

:deep(.ant-card-body){
    padding-bottom: 6px;
}
:deep(.ant-input),:deep(.ant-select){
    background: #f7f8fa;
    border:none;
}
:deep(.ant-select:not(.ant-select-customize-input) .ant-select-selector){
    background: #f7f8fa;
    border:none;
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>
